import React from "react";
import FieldProto from "../../../../proto/field-proto";
import {PopoverParent} from "../../../../@types";
import ModelEntity from "../../../../../model2/model-entity";
import SessionCustomField from "../../../../../model2/custom-field/session-custom-field";


// const debug = "FieldDropdown_PopoverMenuMore"
const debug = false

export type PopoverMenuMoreProps = {
    parent  : PopoverParent //
    field   : FieldProto
    model?  : ModelEntity
}

export default class FieldDropdown_PopoverMenuMore extends React.Component<PopoverMenuMoreProps> {

    onClick = ()=>{

        const customField : SessionCustomField = gd.session.customFields.get(this.props.field.fieldId)!

        debug && console.log(debug, "fieldId=", this.props.field.fieldId, "Session CustomField=", customField)

        this.props.parent.hidePopover()

        if (customField) {
            debug && console.log("this is CF v1 from task/project")
            gd.modals.customField.editCustomFieldV2(customField.id, ()=>{
                debug && console.log(debug, "Modal Edit Done... ")
                gd.modal.hide()
            })
            return

        } else {
            debug && console.log(debug, "This is generic CF i.e. CRM etc... need open other edit")

            gd.modals.customField.editField(
                this.props.field,
                (field: FieldProto, result:any)=>{
                    debug && console.log(debug, 'editField callback', field, result, customField)
                    gd.modal.hide()

                    this.props.field.onOptionsEdited?.(this.props.field)
                },
                {disableRequired: !!customField}
            )

            return
        }

    }

    render() {

        debug && console.log(debug, "render()")

        return (
            <div className="help">
                <div className="flex-row-left-center" onClick={this.onClick}>
                    <div className="ui5-ico-15 i5-wrench m-r-8" />
                    <div className="ui5-txt-link-small-no-accent" >Edit options</div>
                </div>
            </div>
        )

    }
}